// @flow
import React from 'react';
import Box from '../../../components/Box';
import Heading from '../../../components/Heading';
import Button from '../../../components/Button';
import ScrollView from '../../../components/ScrollView';
import { isReactNative } from '../../../app/detectPlatform';
import { remoteLoadFromProps } from '../../../components/hoc/remoteLoad';
import api from '../../../lib/api';
import Spinner from '../../../components/Spinner';
import Text from '../../../components/Text';
import paymentMessages from '../../../messages/payment';
import { compose } from 'rambda';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

class FidelioGuests extends React.PureComponent {
  render() {
    const {
      remotePayload: guests = [],
      remoteError,
      remoteIsLoading,
      isLoading,
      guestId,
      onConfirm,
      intl
    } = this.props;

    return (
      <Box
        width={isReactNative ? null : 20}
        maxHeight={isReactNative ? '100%' : '70vh'}
        marginHorizontal={-1}
        flex={1}
      >
        <Heading scale={2} color="white" marginHorizontal={1}>{intl.formatMessage(paymentMessages.paymentHoresChooseGuest)}</Heading>

        {remoteError ? null : remoteIsLoading
          ? (
            <Box marginTop={4}>
              <Spinner color={isReactNative ? 'gray' : ''} size="large" />
            </Box>
          ) : (
            <Box>
              <ScrollView>
                {guests.map(({
                  id,
                  guest_name: guest,
                  room_code: roomCode
                }) => (
                  <Button
                    key={id}
                    marginHorizontal={1}
                    backgroundColor="white"
                    paddingVertical={0.5}
                    paddingHorizontal={1}
                    marginBottom={0.5}
                    justifyContent="flex-start"
                    disabled={isLoading}
                    flexShrink={0}
                    onPress={() => onConfirm(id, guest, roomCode)}
                  >
                    {isLoading && guestId === id
                      ? <Box marginRight={0.5}><Spinner size="small" /></Box>
                      : null
                    }
                    <Box height="100%">
                      <Text>{guest}</Text>
                      <Text scale={-2}>{`${intl.formatMessage(paymentMessages.paymentHoresRoomNumber)}: ${roomCode}`}</Text>
                    </Box>
                  </Button>
                ))}
              </ScrollView>
            </Box>
          )
        }

        {remoteError ? <Text color="error" marginVertical={1}>{remoteError}</Text> : null}
      </Box>
    );
  }
}

export default compose(
  remoteLoadFromProps(
    api.hores.getFidelioGuests,
    ({ hotelId, code }) => [hotelId, code]
  ),
  connect(),
  injectIntl
)(FidelioGuests);
